function getDefaultState() {
  return {
    token: localStorage.getItem("token") || "",
    user: {
      name: localStorage.getItem("nome") || "",
      comprador: {
        id: localStorage.getItem("comprador_usuario_id"),
        nome: localStorage.getItem("comprador_usuario_nome")
      }
    },
    acessos: [],
    grupo_compras: "1",
    grupos: [],
    filial_compras: "0",
    exibeFilialCompra: false
  };
}

const state = getDefaultState();

const getters = {
  getToken(state) {
    return state.token;
  },
  getAcessos(state) {
    return state.acessos;
  },
  getUser(state) {
    return state.user;
  },
  getComprador(state) {
    return state.user.comprador;
  },
  getGrupoCompras(state) {
    return state.grupo_compras;
  },
  getGrupos(state) {
    return state.grupos;
  },
  getFilialCompras(state) {
    return parseInt(state.filial_compras);
  },
  getExibeFilialCompra(state) {
    return state.exibeFilialCompra;
  }
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setAcessos(state, acesso) {
    state.acessos = acesso;
  },
  setUser(state, user) {
    state.user = user;
  },
  setComprador(state, comprador) {
    state.user.comprador = comprador;
  },
  setGrupoCompras(state, grupo) {
    state.grupo_compras = grupo;
  },
  setGrupos(state, grupo) {
    state.grupos = grupo;
  },
  setFilialCompras(state, filial) {
    state.filial_compras = filial;
  },
  setExibeFilialCompra(state, resp) {
    state.exibeFilialCompra = resp;
  }
};

const actions = {
  setToken: ({ commit }, token) => {
    commit("setToken", token);
  },
  setNome: ({ commit }, nome) => {
    commit("setUser", nome);
  },
  setComprador: ({ commit }, comprador) => {
    commit("setComprador", comprador);
  },
  setAcessos: ({ commit }, acessos) => {
    commit("setAcessos", acessos);
  },
  setGrupoCompras: ({ commit }, grupo) => {
    commit("setGrupoCompras", grupo);
  },
  setGrupos: ({ commit }, grupo) => {
    commit("setGrupos", grupo);
  },
  setFilialCompras: ({ commit }, filial) => {
    commit("setFilialCompras", filial);
  },
  setExibeFilialCompra: ({ commit }, resp) => {
    commit("setExibeFilialCompra", resp);
  }
};

export default { namespaced: true, state, mutations, getters, actions };
